module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.4.13/_next/static/images/hero-desktop-900366db665459b8d6350a8aefa03fb5.webp";